// Static content data for LD Media

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_5e88ad15-a14f-4eb7-a874-cac507979086/artifacts/haj2wfbo_1000000444.jpg";

export const CALENDLY_URL = "https://calendly.com/ldmediaa1/30min";

export const CONTACT = {
  email: "ldmediaa1@gmail.com",
  phone: "+45 91 64 92 29",
  phoneRaw: "+4591649229",
};

export const NAV_LINKS = [
  { label: "Cases", to: "/cases" },
  { label: "Services", to: "/services" },
  { label: "Om os", to: "/om" },
  { label: "Kontakt", to: "/kontakt" },
];

export const FOUNDER = {
  name: "Abbas Khan",
  alias: "Abbas_LD",
  role: "Founder · LD Media",
  story: [
    "LD Media blev grundlagt af Abbas Khan, også kendt som Abbas_LD, med en vision om at hjælpe virksomheder med at vokse gennem moderne marketing, content creation og digitale løsninger.",
    "Gennem flere år arbejdede Abbas med forskellige projekter og opbyggede erfaring inden for content creation, videoredigering, branding og sociale medier. Samtidig udforskede han forskellige forretningsidéer og udviklede en stærk interesse for entreprenørskab.",
    "I 2025 tog Abbas på den sidste store skoletur til Berlin sammen med sin årgang, inden tiden i folkeskolen var slut. Sammen med en ven besluttede han at dokumentere rejsen gennem en film. Da projektet var færdigt, opstod idéen til at bruge de færdigheder, han havde opbygget gennem årene, til at hjælpe virksomheder med indhold, markedsføring og digital vækst.",
    "Det blev starten på LD Media.",
    "I dag hjælper LD Media virksomheder med AI-videoer, content creation, hjemmesider, automatisering og digitale marketingløsninger med fokus på kvalitet, innovation og resultater.",
  ],
};

export const CASES = [
  {
    slug: "mr-fried-chicken",
    name: "Mr. Fried Chicken",
    category: "Restaurant · Fast Food",
    headline: "Stærkere brand og mere synlighed gennem organic marketing",
    description:
      "Vi byggede et organic marketing setup for Mr. Fried Chicken med fokus på at vise restauranten, maden og stemningen fra en mere appetitlig vinkel. Vi stod for ideer, optagelse og redigering, så de fik content der ramte plet hos lokale, og en stærkere tilstedeværelse på sociale medier uden de skulle bekymre sig om det selv.",
    longDescription: [
      "Mr. Fried Chicken er en lokal fast food restaurant der laver fantastisk crispy kylling, men deres online tilstedeværelse afspejlede ikke kvaliteten af deres mad.",
      "Vi gik ind med en organic marketing strategi: nye ideer til content, professionel optagelse i restauranten og redigering der fik maden til at se uimodståelig ud. Vi byggede en kalender for posting og leverede content i et fast tempo.",
      "Resultatet er en restaurant der ser professionel ud online, et tydeligere brand og flere lokale der genkender og besøger Mr. Fried Chicken.",
    ],
    services: ["Organic Marketing", "Content Creation", "Video Redigering"],
    image: "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?auto=format&fit=crop&w=1600&q=80",
    tags: ["Organic Marketing"],
  },
  {
    slug: "phonecycle",
    name: "Phonecycle",
    category: "Tech · Mobil-tilbehør",
    headline: "Byggede hele systemet op fra bunden",
    description:
      "Phonecycle havde stort set ingenting da vi startede. Vi byggede hele systemet op fra bunden: organic Meta ads, organic marketing, scripts, hooks og redigering. På kort tid fik de en stabil tilstedeværelse online og et setup der faktisk leverer henvendelser.",
    longDescription: [
      "Phonecycle havde et stærkt produkt indenfor mobil-tilbehør, men deres digitale fundament var stort set ikke-eksisterende. Ingen content-strategi, ingen ads, ingen flow.",
      "Vi byggede hele deres marketing-system op fra bunden. Det betød: en organic marketing strategi der ramte deres målgruppe, organic Meta ads der varmede potentielle kunder op, og skarpe scripts og hooks der fik folk til at stoppe scroll.",
      "Resultatet er et komplet setup der nu leverer en stabil strøm af henvendelser og synlighed online — uden de selv skal stå for det daglige arbejde.",
    ],
    services: ["Organic Meta Ads", "Organic Marketing", "Scripts & Hooks", "Video Redigering"],
    image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=1600&q=80",
    tags: ["Organic Meta Ads", "Organic Marketing"],
  },
  {
    slug: "dhaba-indian-kitchen",
    name: "Dhaba Indian Kitchen",
    category: "Restaurant · Indian Cuisine",
    headline: "Fra videoer der ikke performede til content der rammer",
    description:
      "Dhaba havde tidligere lavet videoer selv, men de performede ikke rigtig. Vi gik ind med branding og målrettede Meta ads, og producerede content der faktisk fangede stemningen i deres køkken.",
    longDescription: [
      "Dhaba Indian Kitchen serverer autentisk indisk mad af høj kvalitet, men deres tidligere videoer på sociale medier performede ikke godt nok. De fik ikke den synlighed eller engagement de fortjente.",
      "Vi gik ind med en branding-opdatering og målrettede Meta ads kampagner mod den lokale målgruppe. Vi producerede nyt content der ramte hårdere — bedre hooks, bedre redigering og en klar strategi bag hvert eneste opslag.",
      "Resultatet blev et tydeligere brand, videoer der faktisk performer, og annoncer der rammer den rigtige målgruppe på det rigtige tidspunkt.",
    ],
    services: ["Branding", "Meta Ads", "Content Creation"],
    image: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&w=1600&q=80",
    tags: ["Branding", "Meta Ads"],
  },
  {
    slug: "old-barber-lounge",
    name: "The Old Barber Lounge",
    category: "Barbershop · Premium Grooming",
    headline: "Bedre videoer der faktisk fangede opmærksomhed",
    description:
      "For The Old Barber Lounge fokuserede vi på ren organic marketing på TikTok. Vi løftede kvaliteten af deres videoer, byggede skarpe hooks og lavede content der faktisk fangede opmærksomhed i feedet.",
    longDescription: [
      "The Old Barber Lounge er en premium barbershop med et stærkt fysisk udtryk, men deres TikTok-tilstedeværelse manglede den samme kvalitet.",
      "Vi fokuserede 100% på organic marketing på TikTok. Vi løftede video-kvaliteten markant, byggede skarpe hooks der får folk til at stoppe scroll, og producerede content der ramte plet hos deres lokale målgruppe.",
      "Det gav dem et stærkere udtryk, større lokal synlighed og videoer der nu faktisk fanger opmærksomhed i stedet for at blive scrollet forbi.",
    ],
    services: ["Organic Marketing", "TikTok Content", "Video Redigering"],
    image: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?auto=format&fit=crop&w=1600&q=80",
    tags: ["Organic Marketing", "TikTok"],
  },
  {
    slug: "fatbike-eksperten",
    name: "Fatbike Eksperten",
    category: "Fatbikes · Retail",
    headline: "Pr. Video Pakke der løfter både cykler og butik",
    description:
      "Fatbike Eksperten har valgt vores Pr. Video Pakke. Vi står for det hele — fra video-ideer, scripts og hooks, til optagelse, redigering og strategi. Et organic marketing framework der rammer både cyklerne og den nye butik uden at føles som reklame.",
    longDescription: [
      "Fatbike Eksperten er en specialist i fatbikes med en helt ny butik, og har valgt vores Pr. Video Pakke for at få en komplet marketing-løsning uden selv at skulle tænke på det.",
      "Pr. Video Pakken inkluderer: video-ideer, scripts og hooks, professionel optagelse, redigering, strategi og det fulde organic marketing framework. Vi bygger content der føles native og underholdende — men rammer plet på både cyklerne og den nye butik.",
      "Han skal ikke spekulere over hvad næste video skal handle om, hvordan den skal redigeres, eller hvornår den skal postes. Vi tager det hele. Videoerne er blevet markant bedre og mere kreative, og rammer både nuværende fatbike-entusiaster og folk der lige har opdaget butikken.",
    ],
    services: ["Pr. Video Pakke", "Organic Marketing", "Framework", "Scripts & Hooks", "Video Redigering"],
    image: "https://images.unsplash.com/photo-1485965120184-e220f721d03e?auto=format&fit=crop&w=1600&q=80",
    tags: ["Pr. Video Pakke", "Organic Marketing"],
  },
];

export const SERVICES = [
  {
    slug: "meta-ads",
    title: "Meta Ads",
    desc: "Skarpe, konverterende kampagner på Facebook og Instagram. Vi tester kreativt, optimerer dagligt og leverer reel ROAS.",
    bullets: ["Strategi & opsætning", "Creative testing", "Daglig optimering", "Performance rapportering"],
    detail: {
      h1: "Meta Ads bureau der leverer resultater",
      lead:
        "LD Media er et Meta Ads bureau der hjælper danske virksomheder med at få flere kunder gennem Facebook og Instagram annoncer. Vi står for hele processen — fra strategi og creative, til daglig optimering og rapportering.",
      description:
        "Meta Ads er en af de mest effektive kanaler for virksomheder der vil vokse i Danmark. Men det handler ikke om at trykke boost — det handler om skarpe creatives, målrettet publikum og hurtig test-og-optimér tilgang. Vi bygger dit Meta Ads setup fra bunden, sætter tracking op korrekt og optimerer dine kampagner dagligt.",
      forWho: [
        "Danske virksomheder der vil have flere kunder eller leads",
        "Webshops der vil skalere salg lønsomt",
        "Lokale forretninger der vil ramme kunder i deres område",
        "Restauranter, salons og servicevirksomheder",
      ],
      benefits: [
        "Fuld strategi og opsætning af Meta Ads konto",
        "Creative der stopper scroll og konverterer",
        "Daglig optimering og A/B testing",
        "Klar rapportering på det der faktisk betyder noget",
      ],
      keywords: "meta ads bureau, facebook annoncer, instagram annoncer, meta ads danmark",
    },
  },
  {
    slug: "google-ads",
    title: "Google Ads",
    desc: "Fang kunder i søgeøjeblikket. Search, Shopping, Performance Max bygget på højværdi-keywords der konverterer.",
    bullets: ["Search & Shopping", "Performance Max", "Konverterings-tracking", "Bid management"],
    detail: {
      h1: "Google Ads bureau i Danmark",
      lead:
        "Vi hjælper danske virksomheder med at ramme kunder præcis når de søger efter det, du tilbyder. Google Ads er et af de stærkeste værktøjer til at skabe kvalificeret trafik og salg.",
      description:
        "Google Ads virker fordi du fanger folk i købsøjeblikket. Vi bygger Search kampagner, Shopping ads og Performance Max setups der er tunet mod konverteringer — ikke bare klik. Vi håndterer keyword-strategi, bid management, negative keywords og løbende optimering.",
      forWho: [
        "Webshops der sælger produkter online",
        "Servicevirksomheder der modtager leads",
        "B2B virksomheder med længere købsrejser",
        "Lokale forretninger der vil rangere på lokale søgninger",
      ],
      benefits: [
        "Search, Shopping og Performance Max kampagner",
        "Korrekt konverterings-tracking",
        "Løbende keyword og bid optimering",
        "Rapportering direkte på salg og leads",
      ],
      keywords: "google ads bureau, google annoncer, sem, ppc danmark",
    },
  },
  {
    slug: "tiktok-ads",
    title: "TikTok Ads",
    desc: "Gør dit brand viralt. Vi laver native, scroll-stop content der virker for den nye generation af købere.",
    bullets: ["Spark Ads", "UGC creators", "Trend-baseret strategi", "Hooks der virker"],
    detail: {
      h1: "TikTok Ads bureau — når din målgruppe er på TikTok",
      lead:
        "TikTok er ikke længere kun for dansere og Gen Z. Voksne, mødre, fædre, iværksættere og B2B-købere er på TikTok. Vi hjælper danske virksomheder med at nå dem gennem native TikTok annoncer.",
      description:
        "Det der virker på TikTok er det der ikke ligner en annonce. Vi producerer native content, arbejder med Spark Ads (organiske videoer boostet som annoncer), og bygger creative-strategier baseret på trends. Målet er at ramme din målgruppe uden at forstyrre dem.",
      forWho: [
        "Brands der vil ramme yngre og bredere målgrupper",
        "Forretninger der er visuelt stærke (mad, mode, produkter)",
        "Virksomheder der vil bygge kendskab og salg samtidig",
        "Alle der vil have en scroll-stop tilstedeværelse",
      ],
      benefits: [
        "Spark Ads og native TikTok kampagner",
        "UGC creator-matching hvis relevant",
        "Trend-baseret creative strategi",
        "Hooks og scripts der performer",
      ],
      keywords: "tiktok ads bureau, tiktok annoncer, tiktok marketing danmark",
    },
  },
  {
    slug: "organic-marketing",
    title: "Organic Marketing",
    desc: "Vækst uden ad-spend. Vi bygger din organic tilstedeværelse op med skarpt content og en stærk strategi på de platforme der betyder noget.",
    bullets: ["Content-strategi", "Posting-kalender", "Hooks & storytelling", "Vækst på Reels & Shorts"],
    detail: {
      h1: "Organic marketing der bygger dit brand",
      lead:
        "Ad-spend virker, men et stærkt organic fundament er det der bygger langsigtet brand og gør ads billigere. Vi hjælper danske virksomheder med at vokse organisk på TikTok, Instagram og Facebook.",
      description:
        "Organic marketing handler om at ramme din målgruppe uden at betale for hvert eneste view. Vi bygger content-strategier, posting-kalendere, og skarpe hooks der får folk til at stoppe scroll — og bagefter huske dit brand. Vi står for både strategi, content produktion og opfølgning.",
      forWho: [
        "Virksomheder der vil bygge langsigtet brand-kendskab",
        "Lokale forretninger uden stort ad-budget",
        "Founders og små virksomheder der vil vokse organisk",
        "Brands der vil have en stærk stemme online",
      ],
      benefits: [
        "Skræddersyet content-strategi",
        "Konsistent posting på de rigtige platforme",
        "Hooks og storytelling der virker",
        "Vækst på Reels og Shorts uden ad-spend",
      ],
      keywords: "organic marketing, sociale medier bureau, content marketing danmark",
    },
  },
  {
    slug: "social-media-management",
    title: "Social Media Management",
    desc: "Konsistent tilstedeværelse på de platforme der betyder noget. Vi planlægger, producerer og publicerer.",
    bullets: ["Indholdskalender", "Community management", "Reels & Shorts", "Insights & vækst"],
    detail: {
      h1: "Social media bureau — konsistent tilstedeværelse hver uge",
      lead:
        "Konsistens slår kreativitet på sociale medier. Vi tager hele driften af dine sociale kanaler — så du kan fokusere på din virksomhed uden at bekymre dig om næste opslag.",
      description:
        "Vi planlægger din content-kalender, producerer indhold, poster på de rigtige tidspunkter, og håndterer kommentarer og beskeder. Alt sammen tunet mod din målgruppe og dine mål. Ingen ad-hoc posts. Ingen tomme kalendere.",
      forWho: [
        "Virksomheder der vil have en fast tilstedeværelse online",
        "Ejere der ikke selv har tid til at lave content",
        "Brands der vil se professionelle ud hver dag",
        "Alle der vil have kontrol over sine sociale medier",
      ],
      benefits: [
        "Fast indholdskalender og posting-plan",
        "Community management og opfølgning",
        "Reels, Shorts og native content",
        "Løbende insights og vækst",
      ],
      keywords: "social media bureau, social media management, sociale medier danmark",
    },
  },
  {
    slug: "hjemmesider",
    title: "Hjemmesider",
    desc: "Hurtige, lækre og konverteringsoptimerede hjemmesider. Vi bygger fra bunden, så du står med en side der både ser godt ud og sælger.",
    bullets: ["Custom design", "Konverteringsfokus", "Mobile-first", "Klar til SEO"],
    detail: {
      h1: "Hjemmesider der ser godt ud og sælger",
      lead:
        "En hjemmeside der bare ser godt ud er spildte penge. Vi bygger hjemmesider der konverterer — hurtige, mobile-first, klar til SEO, og designet til at få besøgende til at tage det næste skridt.",
      description:
        "Vi bygger custom hjemmesider til danske virksomheder. Hver side er designet med et klart mål: at kunden tager kontakt, køber eller booker. Vi arbejder med hurtig loading, ren kode og struktureret indhold der er klar til Google.",
      forWho: [
        "Virksomheder der har brug for en ny hjemmeside",
        "Ejere med en langsom eller forældet side",
        "Startups der lancerer noget nyt",
        "Brands der vil have en side der matcher deres kvalitet",
      ],
      benefits: [
        "Custom design tilpasset dit brand",
        "Hurtig loading og mobile-first opbygning",
        "Konverteringsfokus i hver sektion",
        "Klar til SEO fra dag ét",
      ],
      keywords: "hjemmeside bureau, webdesign, hjemmeside danmark",
    },
  },
  {
    slug: "seo",
    title: "SEO Optimization",
    desc: "Bliv fundet på Google når dine kunder søger. Teknisk SEO, content og keyword-strategi der får dig op i søgeresultaterne.",
    bullets: ["Teknisk SEO", "Keyword research", "On-page optimering", "Content der ranker"],
    detail: {
      h1: "SEO bureau i Danmark — bliv fundet på Google",
      lead:
        "SEO er en af de bedste langsigtede investeringer en virksomhed kan lave. Vi hjælper danske virksomheder med at rangere højere på Google gennem teknisk optimering, keyword-strategi og content der ranker.",
      description:
        "Vi arbejder med både teknisk SEO (hastighed, struktur, indeksering), on-page SEO (metatags, headings, indhold), og content-strategi. Målet er ikke bare mere trafik — det er den rigtige trafik, der konverterer til kunder.",
      forWho: [
        "Virksomheder der vil rangere på deres vigtigste keywords",
        "Ejere med en side der ikke tiltrækker organisk trafik",
        "Servicevirksomheder der vil vinde lokale søgninger",
        "Brands der vil bygge langsigtet synlighed på Google",
      ],
      benefits: [
        "Teknisk SEO audit og optimering",
        "Keyword research tilpasset dit marked",
        "On-page optimering af eksisterende sider",
        "Content-strategi der ranker over tid",
      ],
      keywords: "seo bureau, seo danmark, google seo, on-page seo",
    },
  },
  {
    slug: "video-redigering",
    title: "Video Redigering",
    desc: "Professionel redigering af dit råmateriale. Vi gør lange optagelser til scroll-stop Reels, Shorts og TikToks der konverterer.",
    bullets: ["Reels & Shorts", "TikTok edits", "Captions & motion", "Color & sound design"],
    detail: {
      h1: "Video redigering til sociale medier og annoncer",
      lead:
        "Video er blevet det vigtigste content-format online. Vi redigerer dit råmateriale til Reels, Shorts, TikToks og ad-creatives der performer.",
      description:
        "Vi håndterer hele redigeringsprocessen — captions, motion graphics, color grading og sound design. Alt bliver tilpasset den platform det skal på, så du får et resultat der ser skarpt ud og faktisk virker.",
      forWho: [
        "Virksomheder der har videomateriale men mangler redigering",
        "Content creators der har brug for skarpe edits",
        "Brands der vil skalere deres video-output",
        "Marketing teams der vil aflaste redigeringen",
      ],
      benefits: [
        "Reels og Shorts optimeret til hver platform",
        "TikTok edits med native look",
        "Captions og motion graphics",
        "Color og sound design",
      ],
      keywords: "videoredigering, video bureau, videomarketing danmark",
    },
  },
  {
    slug: "ugc-content",
    title: "UGC Content",
    desc: "Autentisk user-generated content der bygger tillid og sælger. Vi connecter dig med creators eller producerer det selv i din branding.",
    bullets: ["Creator-matching", "Script & briefing", "Native look", "Klar til ads & organic"],
    detail: {
      h1: "UGC Content der bygger tillid og sælger",
      lead:
        "UGC (User-Generated Content) er en af de mest effektive content-typer i dag. Vi hjælper danske virksomheder med at få autentisk creator-content, der ser native ud og bygger tillid til dit brand.",
      description:
        "Vi kan enten matche dig med creators i vores netværk, eller producere UGC-style content selv i din branding. Alt sammen designet til at ligne rigtige anmeldelser og brugsscenarier — ikke reklame. UGC virker både i ads og organic.",
      forWho: [
        "Brands der vil have autentisk content uden influencer-priser",
        "Webshops der vil vise produkter i brug",
        "Servicevirksomheder der vil dele kundeperspektiver",
        "Virksomheder der vil have skalerbart content til ads",
      ],
      benefits: [
        "Creator-matching hvis relevant",
        "Script og briefing der performer",
        "Native look uden reklame-følelse",
        "Klar til både ads og organic",
      ],
      keywords: "ugc content, ugc bureau, ugc creator danmark",
    },
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Strategi & Lytning",
    desc: "Vi starter altid med at forstå din forretning, dine kunder og dine mål. Ingen skabeloner, kun skræddersyede planer.",
  },
  {
    n: "02",
    title: "Content & Produktion",
    desc: "Vi producerer det content der får folk til at stoppe. Reels, Shorts, UGC og ad-creatives — alt sammen platform-tilpasset.",
  },
  {
    n: "03",
    title: "Lancering & Test",
    desc: "Vi lancerer kampagner med klare hypoteser, tester aggressivt og finder de vinder-kombinationer der skalerer.",
  },
  {
    n: "04",
    title: "Skalering & Vækst",
    desc: "Når formlen virker, skruer vi op. Med klare KPI'er, ugentlig sparring og fuld gennemsigtighed i resultater.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Ejer af Phonecycle",
    role: "Phonecycle",
    quote:
      "I har virkelig leveret et stærkt stykke arbejde med både mine Meta Ads og organic marketing. Det mærkes tydeligt, at I ved præcis, hvad I laver, og jeg føler mig virkelig i gode hænder. Tusind tak.",
    rating: 5,
  },
  {
    name: "Ejer af Mr. Fried Chicken",
    role: "Mr. Fried Chicken",
    quote:
      "Vi er super tilfredse med samarbejdet. De er hurtige, leverer godt content, og vi kan tydeligt mærke forskellen online. Anbefales klart.",
    rating: 5,
  },
];
